/**
 * Keep in sync with `projects/app/public/registerServiceWorker.js` (`isServiceWorkerRegistrationSkippedForBot`).
 */
export const SERVICE_WORKER_REGISTRATION_SKIP_USER_AGENT =
  /Google-Read-Aloud|Googlebot\/|Google-InspectionTool|GoogleProducer/i;

export function shouldSkipServiceWorkerRegistrationForUserAgent(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  return SERVICE_WORKER_REGISTRATION_SKIP_USER_AGENT.test(navigator.userAgent);
}
